<template>
  <div>

    <div v-if="excelDataHtml"
         id="xls-table-wrapp"
         v-html="excelDataHtml">
    </div>

    <div v-if="!excelDataHtml"
         class="row">
      <div class="col-12 text-center text-muted">
        {{ $t("#TR-no-documents-found") }}
      </div>
    </div>

    <main-loader></main-loader>

  </div>
</template>

<script>
  import XLSX from 'xlsx';
  import { ApiFiscalDocs } from '@/services/api';
  import MSG from '@/services/notify';
  import MainLoader from '@/components/Loader';

  export default {
    name: 'CashBookList',

    components: {
      MainLoader
    },

    data() {
      return {
        excelDataHtml: null,
        filter: null
      };
    },

    methods: {
      async getXls(filter) {
        this.$store.commit('toggleLoader', true);
        this.excelDataHtml = null;
        this.$emit('has-export-data', false);
        this.filter = filter;

        const data = await ApiFiscalDocs.ZReport.getXlsbyFilter(filter);

        if (!data) {
          MSG.error('Error: ' + this.$t('#TR-cash-book'), this);
        } else {
          this.$emit('has-export-data', true);

          const fileReader = new window.FileReader();
          fileReader.readAsArrayBuffer(data);
          fileReader.onloadend = async () => {

            const workbook = await XLSX.read(fileReader.result, {
              type: 'array',
              raw: true
            });

            const firstSheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[firstSheetName];

            this.excelDataHtml = await XLSX.utils.sheet_to_html(worksheet, {
              editable: false,
              id: 'xls-table',
              header: '',
              footer: '',
              raw: true
            });
          };
        }

        this.$store.commit('toggleLoader', false);
      },

      download() {
        ApiFiscalDocs.ZReport.downLoadXls(this.filter);
      }
    }
  };
</script>

<style lang="stylus">
#xls-table-wrapp {
  overflow auto
  background: #f6f6f6

  table {
    width: 100%

    tr:nth-child(even) {
      background-color: #fff;
    }

    tr:nth-child(odd) {
      background-color: #ececec;
    }

    td {
      border: 1px solid #ccc !important;
      text-align center
      vertical-align middle
      padding 3px 3px

      font-size 14px
    }
  }
}

.darkmode {
  #xls-table-wrapp {
    background: c-dark-bg
    table {
      tr:nth-child(even) {
        background-color: c-dark-bg-light;
      }
      tr:nth-child(odd) {
        background-color: c-dark-bg;
      }
      td {
        border: 1px solid c-border-dark !important;
      }
    }
  }
}

</style>
